export default {"src":"/_next/static/media/hospital_24.175e7570.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};